module.exports = __webpack_public_path__ + "img/home-active.e72113f8.png";